import { lazy, Suspense, type ComponentType } from 'react';

/** Esqueleto mientras llega el chunk de la ruta (VLT-297). */
export function PageSkeleton() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-4 pt-2" aria-busy="true">
      <div className="skeleton h-16" />
      <div className="skeleton h-72" />
    </div>
  );
}

/** Envuelve una página en lazy+Suspense — cada módulo viaja en su propio chunk. */
// eslint-disable-next-line react-refresh/only-export-components, @typescript-eslint/no-explicit-any
export function lazyEl(load: () => Promise<{ default: ComponentType<any> }>) {
  const C = lazy(load);
  return (
    <Suspense fallback={<PageSkeleton />}>
      <C />
    </Suspense>
  );
}
